export const SESSION_FINDEKS_STATUS = 'sessionFindeksStatus';

export const getSessionStorage = () => {
  try {
    if (typeof window === 'undefined') {
      return null;
    }

    if (!window?.sessionStorage) {
      return null;
    }

    return window.sessionStorage;
  } catch (e) {
    return e;
  }
};

export const saveSessionFindeksStatus = (status) => {
  getSessionStorage()?.setItem(SESSION_FINDEKS_STATUS, status);
};

export const getSessionFindeksStatus = () => {
  let findeksStatus= getSessionStorage()?.getItem(SESSION_FINDEKS_STATUS) || null;

  if (findeksStatus) {
    findeksStatus = JSON.parse(findeksStatus);
  }

  return findeksStatus;
};

export const SEARCH_PROPERTY_ENUMS = {
  FindeksRequirement: 0
}